module.exports = __webpack_public_path__ + "img/2.1.d0e93e30.jpg";